import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build';
import UploadAdapter from './custom_plugin/UploadAdapter';
class Ckeditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ck_data: this.props.value
        }
    }
    async componentDidUpdate(prev_props) {
        if (this.props.value !== prev_props.value) {
            this.setState({
                ck_data: this.props.value
            })
        }
    }
    render() {
        return (
            <div className="editor">
                <CKEditor
                    id="editor"
                    data={this.state.ck_data}
                    editor={ClassicEditor}
                    onReady={editor => {
                        editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                            return new UploadAdapter(loader);
                        };
                    }}
                    onChange={(event, editor) => {
                    }}
                    onBlur={(event, editor) => {
                        const data = editor.getData();
                        this.props.onBlur(data)
                    }}
                    onFocus={(event, editor) => {
                    }}
                />
            </div>
        );
    }
}
export default Ckeditor